import React from 'react';
import { Box, Typography, Table, TableBody, TableCell, TableHead, TableRow, useMediaQuery } from '@mui/material';
import { useTheme } from '@mui/material/styles';
import { useSelector } from 'react-redux';

const TransferHistory = ({ transferHistory, spotWalletId, futuresWalletId, aiWalletId }) => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));
  const { light } = useSelector((state) => state.theme);

  // دالة لتحويل معرف المحفظة إلى اسم المحفظة
  const getWalletName = (walletId) => {
    if (walletId === spotWalletId) return 'Spot Account';
    if (walletId === futuresWalletId) return 'Futures Account';
    if (walletId === aiWalletId) return 'AI Account';
    return 'Unknown Account';
  };

  return (
    <Box
      sx={{
        bgcolor: theme.palette.background.paper,
        p: isMobile ? 2 : 3,
        borderRadius: 2,
        boxShadow: light ? '0 2px 4px rgba(0, 0, 0, 0.1)' : '0 2px 4px rgba(0, 0, 0, 0.5)',
      }}
    >
      <Typography variant={isMobile ? 'h6' : 'h5'} sx={{ color: theme.palette.text.primary, mb: 2 }}>
        Transfer History
      </Typography>
      {transferHistory.length === 0 ? (
        <Typography sx={{ color: theme.palette.text.secondary }}>No transfers yet.</Typography>
      ) : (
        <Box
          sx={{
            maxHeight: 300,
            overflowY: 'auto',
            '&::-webkit-scrollbar': { width: '4px' },
            '&::-webkit-scrollbar-track': { bgcolor: light ? '#E0E0E0' : '#2A2E37' },
            '&::-webkit-scrollbar-thumb': {
              bgcolor: theme.palette.text.secondary,
              borderRadius: '4px',
            },
          }}
        >
          <Table>
            <TableHead>
              <TableRow>
                <TableCell sx={{ color: theme.palette.text.primary, fontSize: isMobile ? '0.8rem' : '1rem' }}>
                  Date
                </TableCell>
                <TableCell sx={{ color: theme.palette.text.primary, fontSize: isMobile ? '0.8rem' : '1rem' }}>
                  From
                </TableCell>
                <TableCell sx={{ color: theme.palette.text.primary, fontSize: isMobile ? '0.8rem' : '1rem' }}>
                  To
                </TableCell>
                <TableCell sx={{ color: theme.palette.text.primary, fontSize: isMobile ? '0.8rem' : '1rem' }}>
                  Asset
                </TableCell>
                <TableCell sx={{ color: theme.palette.text.primary, fontSize: isMobile ? '0.8rem' : '1rem' }}>
                  Amount
                </TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {transferHistory.map((transfer) => (
                <TableRow
                  key={transfer._id}
                  sx={{
                    '&:hover': {
                      bgcolor: light ? '#F0F0F0' : '#3A3E47',
                    },
                  }}
                >
                  <TableCell sx={{ color: theme.palette.text.secondary, fontSize: isMobile ? '0.8rem' : '1rem' }}>
                    {new Date(transfer.created_at).toLocaleString()}
                  </TableCell>
                  <TableCell sx={{ color: theme.palette.text.secondary, fontSize: isMobile ? '0.8rem' : '1rem' }}>
                    {getWalletName(transfer.from_wallet_id)}
                  </TableCell>
                  <TableCell sx={{ color: theme.palette.text.secondary, fontSize: isMobile ? '0.8rem' : '1rem' }}>
                    {getWalletName(transfer.to_wallet_id)}
                  </TableCell>
                  <TableCell sx={{ color: theme.palette.text.secondary, fontSize: isMobile ? '0.8rem' : '1rem' }}>
                    {transfer.asset_id?.symbol || 'USDT'}
                  </TableCell>
                  <TableCell sx={{ color: theme.palette.text.secondary, fontSize: isMobile ? '0.8rem' : '1rem' }}>
                    {transfer.amount.toFixed(2)} USDT
                  </TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </Box>
      )}
    </Box>
  );
};

export default TransferHistory;